import {useEffect, useRef} from 'react';
import {useBasketFlyoutOpenedState} from './useBasketFlyoutOpenedState';

export const useIsBasketFlyoutClosing = () => {
  const {isOpen: currentlyOpen} = useBasketFlyoutOpenedState();
  const prevOpen = useRef(currentlyOpen);

  useEffect(() => {
    prevOpen.current = currentlyOpen;
  });

  return prevOpen.current && !currentlyOpen;
};
